<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-word"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l69.2 69.2 69.2 69.2-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0z"
			/>
			<path
				class="duotone"
				d="M.3 27.7C.3 12.4 12.7 0 27.9 0L249.4 0l0 110.7c0 15.3 12.4 27.7 27.7 27.7l110.7 0 0 345.9c0 15.3-12.4 27.7-27.7 27.7L27.9 512C12.7 512 .3 499.6 .3 484.3L.3 27.7zm321 356.4l15.1-15.8c-3.6-3.7-7.8-6.2-12.6-7.6c-4.8-1.5-9.3-2.3-13.7-2.3c-5.7 0-11.1 .9-16.1 2.7c-5 1.8-9.3 4.5-13.1 7.9c-3.7 3.3-6.5 7.4-8.7 12.2s-3.2 10.1-3.2 16s1.1 11.2 3.2 16s5 8.9 8.7 12.3c3.8 3.3 8.1 5.9 13.1 7.8c5.1 1.8 10.5 2.7 16.1 2.7c4.4 0 8.9-.7 13.7-2.1c4.9-1.5 9.1-4.1 12.6-7.8l-15.1-15.8c-1.3 1.5-2.9 2.8-4.7 4s-4 1.7-6.5 1.7c-5.8 0-10.3-1.7-13.5-5.2c-3.1-3.4-4.7-8-4.7-13.5s1.6-10.1 4.7-13.5c3.2-3.4 7.8-5.2 13.5-5.2c2.3 0 4.5 .6 6.5 1.7c2 1 3.6 2.3 4.7 4zm-142.5-2.9c-2.1 4.8-3.2 10.1-3.2 16s1.1 11.2 3.2 16s5 8.9 8.7 12.3c3.8 3.3 8.1 5.9 13.1 7.8c5.1 1.8 10.5 2.7 16.1 2.7s11-.9 16-2.7c5.1-1.8 9.4-4.4 13.1-7.8c3.8-3.4 6.7-7.6 8.8-12.3s3.2-10.1 3.2-16s-1.1-11.2-3.2-16s-5.1-8.8-8.8-12.2c-3.7-3.4-8-6.1-13.1-7.9c-5-1.8-10.3-2.7-16-2.7s-11.1 .9-16.1 2.7c-5 1.8-9.3 4.5-13.1 7.9c-3.7 3.3-6.5 7.4-8.7 12.2zm24.4 29.5c-3.1-3.4-4.7-8-4.7-13.5s1.6-10.1 4.7-13.5c3.2-3.4 7.8-5.2 13.5-5.2s10.2 1.7 13.4 5.2c3.2 3.5 4.9 8 4.9 13.5s-1.6 10.1-4.9 13.5c-3.1 3.5-7.6 5.2-13.4 5.2s-10.3-1.7-13.5-5.2zM65.6 326.4l0 107.8 38.8 0c8 0 15.7-1.2 23-3.5s13.8-5.7 19.3-10.2c5.6-4.6 10-10.1 13.2-16.7c3.3-6.7 5-14.4 5-23.1c0-9.8-1.7-18.2-5.2-25.1c-3.3-6.9-7.9-12.5-13.7-16.7c-5.8-4.4-12.6-7.5-20.4-9.4c-7.7-1.9-15.9-2.9-24.5-2.9l-35.6 0zm23.7 85.8l0-63.9 14 0c5 0 9.7 .7 14.2 2c4.6 1.2 8.5 3.1 11.9 5.6s6 5.8 7.9 9.7c2 3.9 3 8.4 3 13.7c0 6.1-1 11.3-3 15.5c-1.9 4.2-4.6 7.6-8.1 10.2c-3.5 2.5-7.6 4.4-12.3 5.5c-4.7 1.1-9.7 1.7-15.2 1.7l-12.3 0zM68.3 177.8c-7.6 0-13.8 6.2-13.8 13.8s6.2 13.8 13.8 13.8l149.6 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-149.6 0zM54.5 259.9c0 7.6 6.2 13.8 13.8 13.8l95.2 0c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8l-95.2 0c-7.6 0-13.8 6.2-13.8 13.8z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'WordFileIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #4ab2f7 !important;
}
</style>
